import { useState } from 'react';
import { FiMessageSquare } from 'react-icons/fi';
import { ChevronDown, LogOut, User } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
// import FeedbackModal from '../../components/shared/FeedbackModal';
// import NotificationBell from '../../components/gerant/NotificationBell';
import storage from '../../utils/storage';
import { useAdminAuth } from '../../hooks/useAdminAuth';

export default function HeaderActions() {
  const [isFeedbackModalOpen, setIsFeedbackModalOpen] = useState(false);
  const [isProfileMenuOpen, setIsProfileMenuOpen] = useState(false);
  const navigate = useNavigate();
  const { logout } = useAdminAuth();
  
  const user = storage.getUser();
  const userName = user?.first_name || user?.name || user?.username || 'Utilisateur';
  const userInitials = `${user?.first_name?.[0] || ''}${user?.last_name?.[0] || ''}`.toUpperCase();

  const handleLogout = () => {
    logout();
    navigate('/');
  };

  const handleProfileClick = () => {
    navigate('/profil');
    setIsProfileMenuOpen(false);
  };

  return (
    <>
      <div className="flex items-center gap-2 sm:gap-3.5">
        {/* <button
          onClick={() => setIsFeedbackModalOpen(true)}
          className="flex h-9 w-9 items-center justify-center rounded-full bg-teal-50 text-teal-600 hover:bg-teal-100 transition-colors"
          title="Donner votre avis"
          aria-label="Donner votre avis"
        >
          <FiMessageSquare size={20} />
        </button>
        <NotificationBell /> */}
        
        {/* Profile Menu */}
        <div className="relative">
          <button
            onClick={() => setIsProfileMenuOpen(!isProfileMenuOpen)}
            className="hidden items-center gap-2 rounded-full bg-white px-3 py-1.5 shadow-sm hover:shadow-md transition-shadow sm:flex"
            aria-label="Menu profil"
          >
            <div className="h-8 w-8 rounded-full bg-primary/10 flex items-center justify-center text-xs font-semibold text-primary">
              {userInitials}
            </div>
            <span className="text-sm font-medium text-foreground hidden md:inline">{userName}</span>
            <ChevronDown className="h-4 w-4 text-muted-foreground" />
          </button>

          {/* Dropdown Menu */}
          {isProfileMenuOpen && (
            <div className="absolute right-0 mt-2 w-48 rounded-lg bg-white shadow-lg border border-border z-50">
              <div className="p-3 border-b border-border">
                <p className="text-sm font-medium text-foreground">{userName}</p>
                <p className="text-xs text-muted-foreground">{user?.email}</p>
              </div>
              
              <button
                onClick={handleProfileClick}
                className="w-full flex items-center gap-2 px-4 py-2 text-sm text-foreground hover:bg-muted transition-colors"
              >
                <User className="h-4 w-4" />
                Mon profil
              </button>
              
              <button
                onClick={handleLogout}
                className="w-full flex items-center gap-2 px-4 py-2 text-sm text-destructive hover:bg-destructive/5 transition-colors border-t border-border"
              >
                <LogOut className="h-4 w-4" />
                Se déconnecter
              </button>
            </div>
          )}
        </div>
      </div>

      {/* Close menu when clicking outside */}
      {isProfileMenuOpen && (
        <div
          className="fixed inset-0 z-40"
          onClick={() => setIsProfileMenuOpen(false)}
        />
      )}

      {/* <FeedbackModal isOpen={isFeedbackModalOpen} onClose={() => setIsFeedbackModalOpen(false)} /> */}
    </>
  );
}
